import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-instagram",
  "use": "icon-instagram-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-instagram\">\n    <g fill=\"currentColor\" fill-rule=\"evenodd\">\n        <path d=\"M4.284.82A3.468 3.468 0 0 0 .82 4.285v7.252A3.468 3.468 0 0 0 4.284 15h7.252A3.468 3.468 0 0 0 15 11.536V4.284A3.468 3.468 0 0 0 11.536.821H4.284zm7.252 15H4.284A4.29 4.29 0 0 1 0 11.537V4.284A4.29 4.29 0 0 1 4.284 0h7.252a4.29 4.29 0 0 1 4.285 4.284v7.252a4.29 4.29 0 0 1-4.285 4.285z\" />\n        <path d=\"M7.91 4.48a3.433 3.433 0 0 0-3.43 3.43 3.433 3.433 0 0 0 3.43 3.43c1.891 0 3.43-1.539 3.43-3.43 0-1.89-1.539-3.43-3.43-3.43m0 7.68a4.255 4.255 0 0 1-4.25-4.25 4.255 4.255 0 0 1 4.25-4.25 4.255 4.255 0 0 1 4.25 4.25 4.255 4.255 0 0 1-4.25 4.25M13.317 3.875a.82.82 0 1 0-1.641 0 .82.82 0 0 0 1.641 0\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/instagram.svg
// module id = 1129
// module chunks = 2